<!--
 * @Author: songyzh
 * @Date: 2020-07-31 14:27:33
 * @LastEditors: songyzh
 * @LastEditTime: 2022-05-27 10:59:20
-->
<template>
  <div class="h-full">
    <div class="h-8 w-full flex" style="margin-bottom: 10px">
      <label class="font-bold mx-4 leading-loose">边坡:</label>
      <Select v-model="modelSlope" style="width: 150px" placeholder="请选择边坡" @on-select="onSlopeSelect">
        <Option v-for="item in slopeList" :value="item.value" :key="item.value">{{
          item.label
        }}</Option>
      </Select>
    </div>
    <Table :data="tableData" :columns="tableColumns" stripe border @on-row-click="showDeatil"></Table>
    <!-- <div style="margin: 10px; overflow: hidden">
      <div class="float-right">
        <Page :total="100" :current="1" @on-change="changePage"></Page>
      </div>
    </div> -->
    <Modal v-model="modal" :title="modalTile" footer-hide :width="80" :styles="{ top: '20px' }"
      @on-visible-change="reset">
      <div :style="isCX ? 'height:800px;' : 'height: 500px'" class="w-full h-full">
        <div style="position: absolute; min-width: 370px; right: 20px; top: 5px">
          <Form :label-width="80">
            <Row>
              <Col span="18">
              <FormItem label="时间区间">
                <DatePicker size="small" type="daterange" :split-panels="true" placeholder="选择时间区间"
                  @on-change="dateRangeChange"></DatePicker>
              </FormItem>
              </Col>
              <Col span="5" offset="1" style="margin-top: 5px">
              <Button size="small" type="primary" @click="searchDevices">查询</Button>
              </Col>
            </Row>
          </Form>
        </div>
        <Spin size="large" fix v-if="spinShow"></Spin>
        <v-chart v-if="!isCX" ref="charts" :options="chartOptions" autoresize></v-chart>
        <template v-else>
          <div style="display: flex;">
            <Form ref="formUserAdd" inline :label-width="120">
              <FormItem label="图表坐标轴范围">
                <Input size="small" type="text" style="width:80px;" v-model="chartOptionMinMax.min" placeholder="最小值" />
                <span style="margin:0 5px;">-</span>
                <Input size="small" type="text" style="width:80px;" v-model="chartOptionMinMax.max" placeholder="最大值" />
                <Button size="small" type="primary" style="margin-left:20px;" @click="searchDevices">确定</Button>
              </FormItem>
            </Form>
            <div style="flex: 1;text-align: center;">
              <RadioGroup v-model="currentCxValueKey" size="small" type="button" button-style="solid"
                @on-change="searchDevices">
                <Radio label="V1">X方向</Radio>
                <Radio label="V2">Y方向</Radio>
              </RadioGroup>
            </div>
            <Form ref="formUserAdd" inline :label-width="120">
              <FormItem label="图表坐标轴范围">
                <Input size="small" type="text" style="width:80px;" v-model="chartOption2MinMax.min"
                  placeholder="最小值" />
                <span style="margin:0 5px;">-</span>
                <Input size="small" type="text" style="width:80px;" v-model="chartOption2MinMax.max"
                  placeholder="最大值" />
                <Button size="small" type="primary" style="margin-left:20px;" @click="searchDevices">确定</Button>
              </FormItem>
            </Form>
          </div>
          <Row style="height: calc(100% - 30px);">
            <Col span="12" style="height: 100%;">
            <v-chart ref="charts" :options="chartOptions" autoresize></v-chart>
            </Col>
            <Col span="12" style="height: 100%;">
            <v-chart ref="charts2" :options="chartOptions2" autoresize></v-chart>
            </Col>
          </Row>
        </template>
      </div>
    </Modal>
  </div>
</template>
<script>
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/legendScroll';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoomSlider';
import {
  getDevices,
  getGPSList,
  getDevicesDetail,
  getDevicesDetailCX,
  getDevices1,
  getGPSList1,
  getDevicesDetail1,
  getDevicesDetailCX1,
} from '@/api/gps';

const initDataHash = {
  '530721101000LF04': 37.2,
  '530721101000LF06': 14.4,
  '530721101000LF02': 95,
  '530721101000LF03': 10,
  '530721101000LF05': 3.5
};
const cx01 = {
  DeviceName: '边坡6深部位移监测站CX1-4',
  DeviceType: '测斜仪',
  nodes: [],
  isOn: 0,
  codes: ['530721101000CX01', '530721101000CX02', '530721101000CX03', '530721101000CX04']
};
const cx02 = {
  DeviceName: '边坡6深部位移监测站CX5-8',
  DeviceType: '测斜仪',
  isOn: 0,
  nodes: [],
  codes: ['530721101000CX05', '530721101000CX06', '530721101000CX07', '530721101000CX08']
};
const cx03 = {
  DeviceName: '边坡7深部位移监测站CX9-12',
  DeviceType: '测斜仪',
  nodes: [],
  isOn: 0,
  codes: ['530721101000CX09', '530721101000CX10', '530721101000CX11', '530721101000CX12']
};
const cx04 = {
  DeviceName: '边坡7深部位移监测站CX13-16',
  DeviceType: '测斜仪',
  isOn: 0,
  nodes: [],
  codes: ['530721101000CX13', '530721101000CX14', '530721101000CX15', '530721101000CX16']
};
const cxs = [cx01, cx02, cx03, cx04];
export default {
  data() {
    return {
      modal: false,
      spinShow: true,
      modalTile: '',
      slopeList: [],
      isLJ: false,
      isCX: false,
      currentCxValueKey: 'V1', // 当前测斜显示的值 V1 V2
      currentDeviceCode: null,
      stime: this.formatDate(new Date()),
      etime: this.formatDate(new Date()),
      modelSlope: null,
      deviceType: null,
      chartOptions: {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['北位移', '东位移', '垂向位移']
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          data: [
            '2020-5-18',
            '2020-5-19',
            '2020-5-20',
            '2020-5-21',
            '2020-5-22',
            '2020-5-23',
            '2020-5-24'
          ]
        },
        yAxis: {
          type: 'value',
          min: -20,
          max: 20,
          axisLine: {
            show: false
          }
        },
        series: [
          {
            name: '北位移',
            data: [0, -1.1, 0.1, 0, 2.2, 0.2, -0.2],
            symbol: 'rect',
            type: 'line',
            smooth: true
          },
          {
            name: '东位移',
            data: [0.1, -0.2, 0.3, 0.1, 0.2, -2.2, -0.1],
            type: 'line',
            symbol: 'triangle',
            smooth: true
          },
          {
            name: '垂向位移',
            data: [0.3, 0, 1.1, 0.2, 0.1, -0.1, -0.1],
            type: 'line',
            smooth: true
          }
        ]
      },
      chartOptions2: {},
      chartOptionMinMax: {
        min: '',
        max: '',
      },
      chartOption2MinMax: {
        min: '',
        max: '',
      },
      tableData: [],

      tableColumns: [
        {
          title: '测站名',
          key: 'DeviceName'
        },
        {
          title: '测站类型',
          key: 'DeviceType'
        }
        // {
        //   title: '状态',
        //   key: 'isOn',
        //   width: 200,
        //   render: (h) => {
        //     // const { row } = params;
        //     // const color = row.isOn === 0 ? 'success' : 'error';
        //     // const text = row.isOn === 0 ? '正常' : '预警';
        //     const color = 'success';
        //     const text = '正常';
        //     return h(
        //       'Tag',
        //       {
        //         props: {
        //           type: 'dot',
        //           color
        //         }
        //       },
        //       text
        //     );
        //   }
        // }
        // {
        //   title: '数据',
        //   key: 'overview',
        //   render: (h, params) => {
        //     const { row } = params;
        //     const time = this.rTime(row.timestamp);
        //     const overview = `${time} dN:${row.b} dE:${row.l} dU:${row.h} mm`;
        //     row.overview = overview;
        //     return <span>{overview}</span>;
        //   }
        // }
      ]
    };
  },
  components: {
    'v-chart': ECharts
  },

  async mounted() {
    const { slopeCode } = this.$route.params;
    let datas;
    if (this.$appConfig.isZJ) {
      datas = await getGPSList1();
    } else {
      datas = await getGPSList();
    }
    const points = datas.data;
    const nameMap = {
      新庄停车区边坡监测: '第8合同段',
      仁和互通边坡监测点: '第11合同段',
      六德左幅下边坡监测: '第15合同段',
      永胜枢纽B匝道桥边坡监测: '第17合同段',
      程海收费站右幅边坡监测: '第20合同段'
    };
    const slopes = points.map(point => ({
      value: point.Id,
      label: this.$appConfig.isZJ ? nameMap[point.DangerName] : point.DangerName
    }));
    if (this.$appConfig.isZJ) {
      slopes.sort((a, b) => a.label.replace(/[^\d]/g, '') - b.label.replace(/[^\d]/g, ''));
    } else {
      slopes.sort(
        (a, b) => a.label.charAt(a.label.length - 1) - b.label.charAt(b.label.length - 1)
      );
    }
    debugger;
    this.slopeList = slopes;
    debugger;
    this.modelSlope = slopeCode || this.slopeList[0].value;
    this.getGPS();
    setInterval(() => {
      this.getGPS();
    }, 60000);
  },
  methods: {
    reset() {
      // this.stime = this.formatDate(new Date());
      // this.etime = this.formatDate(new Date());
    },
    async getGPS() {
      let datas;
      if (this.$appConfig.isZJ) {
        datas = await getDevices1(this.modelSlope);
      } else {
        datas = await getDevices(this.modelSlope);
      }
      cxs.forEach(cxItem => {
        // eslint-disable-next-line
        cxItem.nodes = [];
      });
      const tempDatas = [];
      datas.forEach(item => {
        if (item.DeviceName.indexOf('CX') > -1) {
          cxs.forEach(cxItem => {
            if (cxItem.codes.includes(item.DeviceCode)) {
              cxItem.nodes.push(item);
            }
          });
        } else {
          const tempItem = { ...item };
          tempItem.DeviceName = `${item.DeviceName.split('#')[0]}#`;
          tempDatas.push(tempItem);
        }
      });
      cxs.forEach(cxItem => {
        if (cxItem.nodes.length !== 0) {
          tempDatas.push({ ...cxItem });
        }
      });
      if (this.$appConfig.isZJ) {
        tempDatas.sort((a, b) => a.DeviceName.slice(-3, -1) - b.DeviceName.slice(-3, -1));
      }

      this.tableData = tempDatas;
    },
    onSlopeSelect() {
      this.$nextTick(async () => {
        await this.getGPS();
      });
    },
    dateRangeChange(data) {
      [this.stime, this.etime] = data;
    },
    mockTableData() {
      const data = [];
      for (let i = 0; i < 10; i++) {
        data.push({
          sensorName: '302A',
          staName: 'FTTT',
          status: 1,
          timestamp: '2020-10-13T01:48:00.000Z',
          overview: '2020-08-09 16:12:54 302A dN:-1.8 dE:-0.6 dU:-0.7 mm'
        });
      }
      return data;
    },
    formatDate(date) {
      const y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? `0${m}` : m;
      let d = date.getDate();
      d = d < 10 ? `0${d}` : d;
      return `${y}-${m}-${d}`;
    },
    formatTime(date) {
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();

      const hourString = hour < 10 ? `0${hour}` : `${hour}`;
      const minuteString = minute < 10 ? `0${minute}` : `${minute}`;
      const secondString = second < 10 ? `0${second}` : `${second}`;
      return `${hourString}:${minuteString}:${secondString}`;
    },
    rTime(date) {
      const jsonDate = new Date(date).toJSON();
      const currentDate = new Date(new Date(jsonDate) + 8 * 3600 * 1000);
      return `${this.formatDate(currentDate)} ${this.formatTime(currentDate)}`;
    },
    searchDevices() {
      if (this.isCX) {
        this.generateCXOptions(this.currentDeviceCode);
      } else {
        this.generateOptions(this.currentDeviceCode);
      }
    },
    async showDeatil(row) {
      this.modal = true;
      this.spinShow = true;
      this.chartOptions = null;
      this.$refs.charts.showLoading();
      // const time = this.rTime(row.timestamp);
      const overview = `${row.DeviceName} `;
      this.modalTile = overview;
      this.deviceType = row.DeviceType;
      this.currentDeviceCode = row.DeviceCode;
      if (row.DeviceType !== '测斜仪') {
        this.isCX = false;
        await this.generateOptions(row.DeviceCode);
      } else {
        this.isCX = true;
        this.currentCxValueKey = 'V1';
        this.currentDeviceCode = row;
        await this.generateCXOptions(row);
      }

      this.spinShow = false;
    },

    setOptions(date, dN, dE, dU) {
      const legend = this.deviceType === 'GNSS' ? ['北位移', '东位移', '垂向位移'] : [];

      const { yAxis, series } = this.getOption(dN, dE, dU);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: legend
        },
        dataZoom: [
          {
            type: 'slider'
          }
        ],
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          data: date
        },
        yAxis,
        series
      };
      this.$refs.charts.hideLoading();
      this.$refs.charts.clear();
      this.chartOptions = option;
    },
    getOption(dN, dE, dU) {
      debugger;
      let yAxis = {
        type: 'value',
        axisLine: {
          show: false
        }
      };
      let series;
      switch (this.deviceType) {
        case 'GNSS':
          yAxis = {
            type: 'value',
            scale: true,
            axisLabel: {
              formatter: '{value} mm'
            },
            max: 100,
            min: -100,
            splitNumber: 10,
            axisLine: {
              show: false
            }
          };
          series = [
            {
              name: '北位移',
              data: dN,
              symbol: 'rect',
              type: 'line',
              smooth: true,
              markPoint: {
                data: [
                  { type: 'max', name: '最大值' },
                  { type: 'min', name: '最小值' }
                ]
              }
            },
            {
              name: '东位移',
              data: dE,
              type: 'line',
              symbol: 'triangle',
              smooth: true,
              markPoint: {
                data: [
                  { type: 'max', name: '最大值' },
                  { type: 'min', name: '最小值' }
                ]
              }
            },
            {
              name: '垂向位移',
              data: dU,
              type: 'line',
              sooth: true,
              markPoint: {
                data: [
                  { type: 'max', name: '最大值' },
                  { type: 'min', name: '最小值' }
                ]
              }
            }
          ];
          break;
        case '雨量计':
          yAxis = {
            type: 'value',
            splitNumber: 10,
            axisLabel: {
              formatter: '{value} mm'
            },
            axisLine: {
              show: false
            }
          };
          series = [
            {
              name: '降雨量',
              data: dN,
              symbol: 'rect',
              type: 'bar',
              barMaxWidth: 30,
              smooth: true
            }
          ];
          break;
        case '含水率':
          yAxis = {
            type: 'value',
            splitNumber: 10,
            max: 100,
            axisLabel: {
              formatter: '{value} %'
            },
            axisLine: {
              show: false
            }
          };
          series = [
            {
              name: '含水率',
              data: dN,
              symbol: 'rect',
              type: 'line',
              smooth: true
            }
          ];
          break;
        case '裂缝计':
          yAxis = {
            type: 'value',
            axisLabel: {
              formatter: '{value} mm'
            },
            splitNumber: 10,
            axisLine: {
              show: false
            }
          };
          series = [
            {
              name: '开合度',
              data: dN,
              symbol: 'rect',
              type: 'line',
              smooth: true,
              markLine: {
                data: [
                  { type: 'max', name: '最大值' },
                  { type: 'min', name: '最小值' }
                ]
              }
            }
          ];
          break;
        case '测斜仪':
          yAxis = {
            type: 'value',
            axisLabel: {
              formatter: '{value} °'
            },
            splitNumber: 10,
            axisLine: {
              show: false
            }
          };
          series = [
            {
              name: '深部位移',
              data: dN,
              symbol: 'rect',
              type: 'line',
              smooth: true,
              markLine: {
                data: [
                  { type: 'max', name: '最大值' },
                  { type: 'min', name: '最小值' }
                ]
              }
            }
          ];
          break;
        default:
          break;
      }
      return { yAxis, series };
    },
    async generateCXOptions(station) {
      let data = [];
      if (this.$appConfig.isZJ) {
        data = await getDevicesDetailCX1(station.DeviceCode, this.stime, this.etime);
      } else {
        data = await getDevicesDetailCX(station.DeviceCode, this.stime, this.etime);
      }
      if (data === null || data.length === 0) {
        this.$refs.charts.hideLoading();
        this.$refs.charts.clear();
        return;
      }
      data[0].deviceDataDtos.sort((a, b) => a.SensorId * 1 - b.SensorId * 1);
      const yData = data[0].deviceDataDtos.map(item => item.SensorId);

      let allInitValue = [];
      if (station.InitValue) {
        try {
          allInitValue = JSON.parse(station.InitValue);
        } catch (e) {
          console.log(e);
        }
      }
      const service = [];
      const service2 = [];
      const currentCxShowKey = this.currentCxValueKey;
      data.forEach((item) => {
        item.deviceDataDtos.sort((a, b) => a.SensorId * 1 - b.SensorId * 1);
        service.push({
          name: item.time,
          type: 'line',
          symbolSize: 10,
          symbol: 'circle',
          smooth: true,
          data: item.deviceDataDtos.map(elem => (currentCxShowKey === 'V1' ? elem.V1 : elem.V2)),
        });
        service2.push({
          name: item.time,
          type: 'line',
          symbolSize: 10,
          symbol: 'circle',
          smooth: true,
          data: item.deviceDataDtos.map(elem => {
            const nowInitItem = allInitValue.find(e => e.SensorId === elem.SensorId);
            let value = 0;
            if (currentCxShowKey === 'V1') {
              value = elem.V1 - (nowInitItem && nowInitItem.InitValue1 ? nowInitItem.InitValue1 : 0);
            } else {
              value = elem.V2 - (nowInitItem && nowInitItem.InitValue2 ? nowInitItem.InitValue2 : 0);
            }
            return value.toFixed(2);
          })
        });
      });
      const option = {
        title: {
          show: true,
          top: '10',
          left: 'center',
          text: `${currentCxShowKey === 'V1' ? 'X' : 'Y'}方向测值(mm)`,
        },
        legend: {
          type: 'scroll',
          left: '3%',
          top: '50',
          bottom: ' 20',
          orient: 'vertical',
        },
        tooltip: {
          trigger: 'item',
          formatter: '时间：{a}<br/>深度：{b}m<br/>测值：{c}<br/>',
        },
        grid: {
          top: '50',
          left: '200',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          },
          min: (value) => {
            if (this.chartOptionMinMax.min) {
              return this.chartOptionMinMax.min;
            }
            return value.min - 10;
          },
          max: (value) => {
            if (this.chartOptionMinMax.max) {
              return this.chartOptionMinMax.max;
            }
            return value.max + 10;
          },
        },
        yAxis: {
          type: 'category',
          axisLine: { onZero: false },
          axisLabel: {
            formatter: '{value} m'
          },
          boundaryGap: false,
          inverse: true,
          data: yData
        },
        series: service,
      };
      this.$refs.charts.hideLoading();
      this.$refs.charts.clear();
      this.chartOptions = option;

      const option2 = {
        title: {
          show: true,
          top: '10',
          left: 'center',
          text: `${currentCxShowKey === 'V1' ? 'X' : 'Y'}方向累计值(mm)`,
        },
        legend: {
          type: 'scroll',
          left: '3%',
          top: '50',
          bottom: ' 20',
          orient: 'vertical',
        },
        tooltip: {
          trigger: 'item',
          formatter: '时间：{a}<br/>深度：{b}m<br/>累计值：{c}<br/>',
        },
        grid: {
          top: '50',
          left: '200',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          },
          min: (value) => {
            if (this.chartOption2MinMax.min) {
              return this.chartOption2MinMax.min;
            }
            return value.min - 10;
          },
          max: (value) => {
            if (this.chartOption2MinMax.max) {
              return this.chartOption2MinMax.max;
            }
            return value.max + 10;
          },
        },
        yAxis: {
          type: 'category',
          axisLine: { onZero: false },
          axisLabel: {
            formatter: '{value} m'
          },
          boundaryGap: false,
          inverse: true,
          data: yData
        },
        series: service2,
      };
      this.$refs.charts2.hideLoading();
      this.$refs.charts2.clear();
      this.chartOptions2 = option2;
    },
    /**
     * 2025年4月17日修改后不用
     * 之前旧版获取测斜选项
     */
    async generateCXOptions_old(codes) {
      const promises = [];
      const titles = [];
      for (let i = 0; i < codes.length; i++) {
        titles.push(`测斜传感器${codes[i].slice(-2)}`);
        promises.push(getDevicesDetail(codes[i], this.stime, this.etime));
      }
      const allData = [];

      Promise.all(promises).then(datas => {
        const commonData = datas[0];
        const dateList = [];
        commonData.forEach(item => {
          dateList.push(item.DeviceDataTime);
        });

        datas.forEach(data => {
          const itemData = data;

          const dNlist = [];
          itemData.forEach(childData => {
            dNlist.push(childData.V1);
          });
          allData.push(dNlist);
        });

        this.setCXOptions(dateList, allData, titles);
      });
    },

    setCXOptions(dateList, allData, titles) {
      const option = {
        legend: {
          data: titles
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          data: dateList
        },
        yAxis: {
          type: 'value',
          gridIndex: 0,
          axisLabel: {
            formatter: '{value} °'
          },
          splitNumber: 10,
          axisLine: {
            show: false
          }
        },
        series: [
          {
            name: titles[0],

            data: allData[0],
            symbol: 'rect',
            type: 'line',
            smooth: true,
            markLine: {
              data: [
                { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' }
              ]
            }
          },
          {
            name: titles[1],

            data: allData[1],
            symbol: 'rect',
            type: 'line',
            smooth: true,
            markLine: {
              data: [
                { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' }
              ]
            }
          },
          {
            name: titles[2],

            data: allData[2],
            symbol: 'rect',
            type: 'line',
            smooth: true,
            markLine: {
              data: [
                { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' }
              ]
            }
          },
          {
            name: titles[3],
            data: allData[3],
            symbol: 'rect',
            type: 'line',
            smooth: true,
            markLine: {
              data: [
                { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' }
              ]
            }
          }
        ]
      };

      this.$refs.charts.clear();
      this.$refs.charts.hideLoading();
      this.chartOptions = option;
    },
    async generateOptions(station) {
      // const startDate = '2020-09-28';
      // const now = new Date();
      // const endDate = this.formatDate(now);
      // let data = await getGPSDeatil(station, startDate, endDate);
      let data;
      this.isLJ = station.indexOf('LJ') > -1;
      const temp = station.split('GP');
      if (temp.length > 1) {
        if (Number(temp[1]) > 42) {
          this.isLJ = true;
        } else {
          this.isLJ = false;
        }
      } else {
        this.isLJ = false;
      }
      if (this.isLJ) {
        data = await getDevicesDetail(station, this.stime, this.etime);
      } else if (this.$appConfig.isZJ) {
        data = await getDevicesDetail1(station, this.stime, this.etime);
      } else {
        data = await getDevicesDetail(station, this.stime, this.etime);
      }

      const dateList = [];
      const dNList = [];
      const dEList = [];
      const dUList = [];
      const V1 = data.reduce((total, item) => total + item.V1, 0) / data.length;
      const V2 = data.reduce((total, item) => total + item.V2, 0) / data.length;
      const V3 = data.reduce((total, item) => total + item.V3, 0) / data.length;

      if (data && Array.isArray(data)) {
        data.forEach(item => {
          // dateList.push(this.rTime(item.timestamp).split(' ')[0]);
          dateList.push(item.DeviceDataTime);
          if (this.isLJ) {
            const id = item.DeviceId;
            let v1;
            let v2;
            let v3;
            switch (id) {
              case 102:
                v1 = (item.V1 + 41.068) * 1000;
                v2 = (item.V2 + 9.8567) * 1000;
                v3 = (item.V3 - 14.9424) * 1000;
                break;
              case 103:
                v1 = (item.V1 + 39.2436) * 1000;
                v2 = (item.V2 - 0.7364) * 1000;
                v3 = (item.V3 - 6.72214) * 1000;
                break;
              case 104:
                v1 = (item.V1 - 83.5792) * 1000;
                v2 = (item.V2 + 26.0937) * 1000;
                v3 = (item.V3 - 4.42667) * 1000;
                break;
              case 105:
                v1 = (item.V1 - 79.2894) * 1000;
                v2 = (item.V2 + 35.9175) * 1000;
                v3 = (item.V3 - 12.3641) * 1000;
                break;
              case 106:
                v1 = (item.V1 - 102.2314) * 1000;
                v2 = (item.V2 + 53.719) * 1000;
                v3 = (item.V3 - 19.5609) * 1000;
                break;
              case 107:
                v1 = (item.V1 - 53.193) * 1000;
                v2 = (item.V2 + 39.6228) * 1000;
                v3 = (item.V3 - 20.4657) * 1000;
                break;
              case 108:
                v1 = (item.V1 + 23.097) * 1000;
                v2 = (item.V2 + 10.7895) * 1000;
                v3 = (item.V3 - 23.8091) * 1000;
                break;
              case 109:
                v1 = (item.V1 + 14.1274) * 1000;
                v2 = (item.V2 + 6.4439) * 1000;
                v3 = (item.V3 - 15.9223) * 1000;
                break;
              case 110:
                v1 = (item.V1 + 6.5093) * 1000;
                v2 = (item.V2 + 4.3969) * 1000;
                v3 = (item.V3 - 8.0462) * 1000;
                break;
              case 112:
                v1 = (item.V1 - 9.2894) * 1000;
                v2 = (item.V2 - 2.674) * 1000;
                v3 = (item.V3 + 8.00271) * 1000;
                break;
              case 113:
                v1 = (item.V1 - 5.9687) * 1000;
                v2 = (item.V2 + 30.7388) * 1000;
                v3 = (item.V3 - 8.69816) * 1000;
                break;
              case 114:
                v1 = (item.V1 + 18.1794) * 1000;
                v2 = (item.V2 - 19.1483) * 1000;
                v3 = (item.V3 - 7.39251) * 1000;
                break;
              default:
                v1 = ((item.V1 - V1 > 0 ? item.V1 - V1 : item.V1 - V1) * 1000).toFixed(2);
                v2 = ((item.V2 - V2 > 0 ? item.V2 - V2 : item.V2 - V2) * 1000).toFixed(2);
                v3 = ((item.V3 - V3 > 0 ? item.V3 - V3 : item.V3 - V3) * 1000).toFixed(2);
            }
            dNList.push(v1.toFixed(3));
            dEList.push(v2.toFixed(3));
            dUList.push(v3.toFixed(3));
            // dNList.push(
            //   ((item.V1 - V1 > 0 ? item.V1 - V1 : item.V1 - V1) * 1000).toFixed(
            //     2
            //   )
            // );
            // dEList.push(
            //   ((item.V2 - V2 > 0 ? item.V2 - V2 : item.V2 - V2) * 1000).toFixed(
            //     2
            //   )
            // );
            // dUList.push(
            //   ((item.V3 - V3 > 0 ? item.V3 - V3 : item.V3 - V3) * 1000).toFixed(
            //     2
            //   )
            // );
          } else if (initDataHash[station]) {
            dNList.push(item.V1 - initDataHash[station]);
          } else {
            dNList.push(item.V1);
            dEList.push(item.V2);
            dUList.push(item.V3);
          }
        });
      }

      this.setOptions(dateList, dNList, dEList, dUList);
    }
  }
};
</script>
<style lang="scss" scoped>
.echarts {
  width: 100%;
  height: 100%;
}
</style>
